import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { GetAllDsrItemsResponse, DsrItem, CostDatabaseItem } from "@ServerTypes/dsr/dsr.schema";

const dsrItemsSlice = createSlice({
  name: "dsrItems",
  initialState: [] as DsrItem[],
  reducers: {
    getDsrItems: (_state: DsrItem[], action: PayloadAction<DsrItem[]>) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action): action is PayloadAction<unknown> => action.type === "dsr/getDsrItemsData/fulfilled",
      (_state, action) => (action.payload as GetAllDsrItemsResponse).result as DsrItem[] ?? [],
    );
  },
});

const costDatabaseSlice = createSlice({
  name: "costDatabase",
  initialState: {} as CostDatabaseItem,
  reducers: {
    setCostDatabase: (_state: CostDatabaseItem, action: PayloadAction<CostDatabaseItem | undefined>) =>
      action.payload ?? {},
  },
});

export const { setCostDatabase } = costDatabaseSlice.actions;

export const getDsrItems = dsrItemsSlice.reducer;
export const costDatabase = costDatabaseSlice.reducer;
